<template>
    <!--商品-->
    <div class="cour-infor">
        <div class="c-banner fl">
            <img class="course-banner" :src="work.imggzxx">
        </div>
        <div class="fr cour-right">
            <div class="crtitle">
                <a>{{work.gzleibie}}</a>—
                <a>{{work.gzxiangmu}}</a>
            </div>
            <div class="selectgoods-leixing">
                <div v-on:click="oktype = true" v-bind:class="oktype ? 'imv2-checkbox':'imv2-checkbox_onk'"
                     class='select-course-radio'><span>初学</span> ￥{{work.gzcxjg}}.00
                </div>
                <div v-on:click="oktype = false" v-bind:class="oktype ? 'imv2-checkbox_onk' :'imv2-checkbox'"
                     class='select-course-radio'><span>复审/换证</span> ￥{{work.gzfsjg}}.00
                </div>
            </div>
            <div class="selectgoods-div-top">
                <span class="selectgoods-tb-type">数量</span>
                <span class="selectgoods-tb-stock">
                <a href="javascript:void(0);" @click="reduce()" title="减1">-</a>
                 <input type="number" class="tb-text" v-on:input="changenumber()" v-model="buyNumber" maxlength="2"
                        title="请输入购买量"/>
                <a href="javascript:void(0);" @click="addnumber()" title="加1">+</a>
                </span>
                <div class="clear"></div>
            </div>
            <div class="selectgoods-goumaibtn">
                <div class="selectgoods-tb-btn-buy">
                    <a href="javascript:void(0);" @click="likegoumai()" title="点击此按钮，到下一步确认购买信息">
                        立即购买
                    </a>
                </div>
                <div class="selectgoods-tb-btn-add">
                    <a href="javascript:void(0);" @click="addShoppingCart()" title="加入购物车" class="J_LinkAdd">
                        <i class="icon-shopping-cart selectgoods-shopping-ion"></i>加入购物车
                    </a>
                </div>
                <div class="clear"></div>
            </div>
            <div class="selectgoods-cont">
                <allcount :work="getcont"/>
            </div>
        </div>
        <div class="clear"></div>
        <!-- template -->
        <Model v-bind:mdShow="mdShow" v-on:close="closeModal">
            <p slot="message">
                已加入到购物车中!
            </p>
            <div slot="btnGroup">
                <a href="javascript:void(0);" class="btnGroup-left-a" @click="mdShow = false , buyNumber = 1">继续购买</a>
                <a href="/cart" class="btnGroup-reg-a" @click="mdShow = false , buyNumber = 1">去购物车结算</a>
            </div>
        </Model>
        <!-- methods -->
        <login v-bind:loginShow="loginShow" v-bind:activeName="activeName" @close="closeloginModal"/>
    </div>

</template>

<script>
    import '../assets/css/selectgoods.css'
    import Model from './model'
    import Login from "./login";
    import Allcount from "./allcount";
    import axios from 'axios';

    export default {
        name: "Selectgoods",
        props: ['work'],
        computed: {
            userNeme() {
                return this.$store.state.userNeme;
            }
        },
        data() {
            return {
                activeName: "login",
                loginShow: false,
                mdShow: false,
                oktype: true,
                buyNumber: 1,
                maxNumber: 99,
                getcont:this.work
            }
        },
        components: {
            Allcount,
            Login,
            Model,
            axios
        },
        methods: {
            closeModal() {
                this.mdShow = false;
                this.buyNumber = 1;
                // this.mdShowCart = false;
            },
            addnumber() {
                if (this.buyNumber < this.maxNumber) {
                    this.buyNumber++;
                }
            },
            reduce() {
                if (this.buyNumber > 1) {
                    this.buyNumber--;
                }
            },
            changenumber() {
                if (this.buyNumber > this.maxNumber) {
                    this.buyNumber = this.maxNumber;
                } else if (this.buyNumber < 1) {
                    this.buyNumber = 1;
                }
            },
            //点击立刻购买
            likegoumai() {
                if (this.userNeme == "") {
                    this.showloginModal("login");
                } else {
                    axios.post("/Api/admin/addTheGoods",
                        {
                            usermobile: this.$store.state.userNeme,
                            jobsdataId: this.work._id,
                            gzleibie: this.work.gzleibie,
                            gzxiangmu: this.work.gzxiangmu,
                            gzleixing: this.oktype ? "初学" : "复审/换证",
                            gzprice: this.oktype ? this.work.gzcxjg : this.work.gzfsjg,
                            buyNumber: this.buyNumber
                        }
                    ).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                //更新购物车数量
                                axios.post("/Api/admin/getStoreNumber").then(res => {
                                    if (res.statusText == "OK") {
                                        if (res.data.errcode == 0) {
                                            this.$store.commit('upcartCount', res.data.data);
                                        } else if (res.data.errcode == 40000) {
                                            // this.$store.commit('upcartCount', res.data.data);
                                        } else {
                                            this.$store.commit('upcartCount', 0);
                                        }
                                    }
                                });
                                this.$router.push({
                                    name: 'Cart'
                                });

                            } else if (res.data.errcode == 40000) {
                                this.showloginModal("login");
                                //请先登入
                                this.$message({
                                    showClose: true,
                                    message: '请先登入',
                                    type: 'error',
                                    duration: 5000
                                });

                            } else {
                                this.$message({
                                    showClose: true,
                                    message: '保存商品失败',
                                    type: 'error',
                                    duration: 5000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '保存商品失败！',
                                type: 'error',
                                duration: 5000
                            });
                        }
                    });
                }
            },
            //点击加入购物车
            addShoppingCart() {
                if (this.userNeme == "") {
                    this.showloginModal("login");
                    //请先登入
                    this.$message({
                        showClose: true,
                        message: '请先登入',
                        type: 'error',
                        duration: 5000
                    });
                } else {
                    axios.post("/Api/admin/addTheGoods",
                        {
                            usermobile: this.$store.state.userNeme,
                            jobsdataId: this.work._id,
                            gzleibie: this.work.gzleibie,
                            gzxiangmu: this.work.gzxiangmu,
                            gzleixing: this.oktype ? "初学" : "复审/换证",
                            gzprice: this.oktype ? this.work.gzcxjg : this.work.gzfsjg,
                            buyNumber: this.buyNumber
                        }
                    ).then(res => {
                        if (res.statusText == "OK") {
                            if (res.data.errcode == 0) {
                                this.mdShow = true;
                                //更新购物车数量
                                axios.post("/Api/admin/getStoreNumber").then(res => {
                                    if (res.statusText == "OK") {
                                        if (res.data.errcode == 0) {
                                            this.$store.commit('upcartCount', res.data.data);
                                        } else if (res.data.errcode == 40000) {
                                            // this.$store.commit('upcartCount', res.data.data);
                                        } else {
                                            this.$store.commit('upcartCount', 0);
                                        }
                                    }
                                });
                            } else if (res.data.errcode == 40000) {
                                this.showloginModal("login");
                                //请先登入
                                this.$message({
                                    showClose: true,
                                    message: '请先登入',
                                    type: 'error',
                                    duration: 5000
                                });

                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error',
                                    duration: 5000
                                });
                            }

                        } else {
                            //操作失败
                            this.$message({
                                showClose: true,
                                message: '保存商品失败！',
                                type: 'error',
                                duration: 5000
                            });
                        }
                    });
                }
            }
            ,
            //显示登入modal
            showloginModal(obj) {
                this.loginShow = true;
                this.activeName = obj;
            }
            ,
            //关闭登入modal
            closeloginModal() {
                this.loginShow = false;
            }
        }
    }
</script>
